
export const ATTRIBUTE_OPTIONS = [
  { label: "Testcase Name", value: "Testcase Name" },
  { label: "Testcase Description", value: "Testcase Description" },
  { label: "Test Step Description", value: "Test Step Description" },
  { label: "Expected Results", value: "Expected Results" },
  { label: "Pre-Condition", value: "Pre-Condition" },
  { label: "Major Functional Area", value: "Major Functional Area" },
  { label: "Designer", value: "Designer" },
  { label: "Test Data Requirement", value: "Test Data Requirement" }
];

export const preProcessingMetaDataColumns = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color:"#ffffff",
      padding: "4px 8px",
      width: "50px"
    },
    cellStyles: {
      width: "50px"
    },
    _config: {
      type: "checkbox",
      displayInColumn: true,
      value: "id",
      isClickable: "true"
    }
  },
  {
    display_name: "#",
    key: "serial_number",
    headerStyles: {
      width: "10%",
    },
  },
  {
    display_name: "Attribute",
    key: "featureName",
    _config: {
      type: "input",
      placeholder: "Enter attribute..",
      value: "",
      displayInColumn: false,
      options: ATTRIBUTE_OPTIONS,
    },
  },
  {
    display_name: "Width (characters)",
    key: "width",
    _config: {
      type: "input",
      inputType: "number",
      value: "0",
    },
  },
  {
    display_name: "Type",
    key: "type"
  },
  {
    display_name: "Require for Model Build",
    key: "requireForModel",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
    },
    _config: {
      type: "select",
      value: "",
      options: [
        {
          label: "Yes",
          value: "Yes",
        },
        {
          label: "No",
          value: "No",
        },
      ],
    },
  }
];
